import { isAvailable, FDealType, FOfferType } from '../../../../../packages/JsonQuery';
import { IFilterSet, TFilter } from 'shared/types/filters';

const HEAD: TFilter[] = ['dealType', 'offerType'];
const TAIL: TFilter[] = ['geo', 'price'];
const FOOT: TFilter[] = ['advancedFilters', 'isByCommercialOwner'];
const FOOT_WITHOUT_OWNER: TFilter[] = ['advancedFilters'];

export const COMMERCIAL_FILTERS_SET: IFilterSet<TFilter>[] = [
  {
    availability: isAvailable(FDealType.RentLongterm, FOfferType.Workplace),
    list: [...HEAD, 'workplaceType', 'workplaceCount', ...TAIL, ...FOOT_WITHOUT_OWNER],
  },
  {
    availability: isAvailable(FDealType.RentLongterm, FOfferType.Coworking),
    list: [...HEAD, 'workplaceCount', ...TAIL, ...FOOT_WITHOUT_OWNER],
  },
  {
    availability: isAvailable(
      FDealType.Sale,
      FOfferType.Business | FOfferType.RentalBusiness | FOfferType.ReadyBusiness,
    ),
    list: [...HEAD, 'businessAppointmentsCategory', ...TAIL, ...FOOT_WITHOUT_OWNER],
  },
  {
    availability: isAvailable(FDealType.Any, FOfferType.Commercial),
    list: [...HEAD, ...TAIL, 'totalArea', ...FOOT],
  },
];
